export default __webpack_public_path__ + "static/media/astro.83e705b1.png";